import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./Classes.css";

export default function ClassArchivedList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [archivedClasses, setArchivedClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [students, setStudents] = useState([]);

  const loadArchived = async () => {
    try {
      const res = await API.get("/school-admin/classes/archived/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setArchivedClasses(res.data.classes || []);
    } catch (err) {
      console.error("Error loading archived classes", err);
    }
  };

  const loadStudents = async (classId) => {
    try {
      const res = await API.get(`/school-admin/classes/${classId}/students/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setStudents(res.data.students || []);
      setSelectedClassId(classId);
    } catch (err) {
      console.error("Error loading students", err);
    }
  };

  const handleToggle = (classId) => {
    if (selectedClassId === classId) {
      setSelectedClassId(null);
      setStudents([]);
    } else {
      loadStudents(classId);
    }
  };

  const restoreClass = async (id) => {
    if (!window.confirm("Restore this class?")) return;
    try {
      await API.post(`/school-admin/classes/${id}/restore/`, {}, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      loadArchived();
    } catch {
      alert("Error restoring class");
    }
  };

  const deleteClassPermanently = async (id) => {
    if (!window.confirm("Delete permanently? This cannot be undone!")) return;
    try {
      await API.delete(`/school-admin/classes/${id}/permanent-delete/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      loadArchived();
    } catch {
      alert("Failed to delete permanently");
    }
  };

  useEffect(() => { loadArchived(); }, []);

  return (
    <div className="arc-page">

      {/* HERO */}
      <div className="arc-hero">
        <div className="arc-hero-left">
          <span className="arc-hero-icon">📦</span>
          <div>
            <h1 className="arc-hero-title">Archived Classes</h1>
            <p className="arc-hero-sub">{archivedClasses.length} archived classes</p>
          </div>
        </div>
        <button className="arc-back-btn" onClick={() => navigate("/school-admin/classes")}>
          ← Back to Classes
        </button>
      </div>

      {/* GRID */}
      {archivedClasses.length === 0 ? (
        <div className="arc-empty">
          <div className="arc-empty-icon">📭</div>
          <p>No archived classes found</p>
        </div>
      ) : (
        <div className="arc-grid">
          {archivedClasses.map((c) => (
            <div key={c.id} className="arc-card">
              <div className="arc-card-top">
                <span className="arc-badge">Archived</span>
                <p className="arc-card-name">{c.name}</p>
              </div>
              <div className="arc-card-body">
                <div className="arc-btn-row">
                  <button
                    className="arc-btn-restore"
                    onClick={(e) => { e.stopPropagation(); restoreClass(c.id); }}
                  >
                    ↩ Restore
                  </button>
                  <button
                    className="arc-btn-delete"
                    onClick={(e) => { e.stopPropagation(); deleteClassPermanently(c.id); }}
                  >
                    🗑
                  </button>
                </div>
              </div>
              <button
                className="arc-expand-toggle"
                onClick={() => handleToggle(c.id)}
              >
                {selectedClassId === c.id ? "▲ Hide Students" : "▼ View Students"}
              </button>
              {selectedClassId === c.id && (
                <div className="arc-students-box">
                  <h4>Students in {c.name}</h4>
                  {students.length === 0 ? (
                    <p className="arc-no-students">No students found</p>
                  ) : (
                    students.map((s) => (
                      <span key={s.id} className="arc-student-pill">
                        {s.name}
                      </span>
                    ))
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
